import { MenuProps } from "antd";
import styles from "./index.module.css";
import { CustomButton } from "Components/CustomButton";
import arrowsOutLineVertical from "assets/svg/ArrowsOutLineVertical.svg";
import { useEffect, useRef, useState } from "react";
import { CustomDropdown } from "Components/CustomDropdown";
import { SessionExtra } from "./SessionExtra/SessionExtra";
import { GetUserSessionsType } from "helpers/backend_helper";
import { SelectedSessionType } from "./types";
import { formatChatSeparatorDate } from "helpers/format";

type Props = {
  actionText: string;
  onAction: () => void;
  onGoToUser: () => void;
  onActionLoading: boolean;
  userSessions: GetUserSessionsType;
  loadingSessions: boolean;
  onSelectedSession: (sessionId: string) => void;
};
export const SessionChatComponent = ({
  onAction,
  onGoToUser,
  actionText,
  userSessions,
  loadingSessions,
  onActionLoading,
  onSelectedSession,
}: Props) => {
  const [selectedSessionKey, setSelectedSessionKey] = useState<string>();
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
  };

  const [items, setItems] = useState<MenuProps["items"]>([]);

  useEffect(() => {
    if (!userSessions) return;

    if (!userSessions.lastSessionId) {
      setSelectedSession(null);
      return;
    }

    const parsedSessions = userSessions.sessions.map((v) => {
      const takenAt = formatChatSeparatorDate(v.takenAt);
      const closedAt = formatChatSeparatorDate(v.closedAt);
      const dates = `${takenAt}${closedAt ? `- ${closedAt}` : ""}`;

      const takenBy = `${v?.takenByAdmin?.id.slice(0, 7)}${
        v.closedByAdmin ? `- ${v.closedByAdmin?.id.slice(0, 7)}` : ""
      }`;
      return {
        takenAt,
        closedAt,
        dates,
        takenBy: v?.takenByAdmin?.id ? takenBy : null,
        id: v.id,
        lastMessageId: v?.lastMessage?.id.toString(),
      };
    });

    const itemsCooked: MenuProps["items"] = parsedSessions.map((v) => {
      const session = {
        key: v.id,
        label: <SessionExtra dates={v.dates} key={v.id} messageId={v.lastMessageId} supportId={v.takenBy} />,
        onClick: (info) => {
          setSelectedSessionKey(info.key);
          setSelectedSession(v);
          close();
          onSelectedSession(v.id);
        },
      };
      return session;
    });

    setSelectedSession(parsedSessions.find((v) => v.id === userSessions.lastSessionId));
    setSelectedSessionKey(userSessions.lastSessionId);
    setItems(itemsCooked);
  }, [userSessions]);

  const [selectedSession, setSelectedSession] = useState<SelectedSessionType>(null);

  const refDiv = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (refDiv.current && !refDiv.current.contains(e.target as Node)) {
        close();
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return selectedSession ? (
    <div className={styles.wrapper} ref={refDiv}>
      <CustomDropdown
        rootClassName={styles.root}
        openClassName={styles.open}
        menu={{ items, selectedKeys: [selectedSessionKey], selectable: true }}
        trigger={["click"]}
        open={isOpen}
      >
        <div className={styles.selectedSession}>
          <div className={styles.infoWrapper}>
            <span>Message ID</span>
            <span>{selectedSession.lastMessageId}</span>
          </div>
          {selectedSession.takenBy ? (
            <div className={styles.infoWrapper}>
              <span>Support ID</span>
              <span>{selectedSession.takenBy}</span>
            </div>
          ) : null}
          {selectedSession.dates ? (
            <div className={styles.infoWrapper}>
              <span>Dates</span>
              <span>{selectedSession.dates}</span>
            </div>
          ) : null}
          <div className={styles.buttonsWrapper}>
            <CustomButton sizeButton="medium" typeButton="secondary" onClick={onGoToUser}>
              Go to User
            </CustomButton>
            {actionText && items.length && !loadingSessions ? (
              <CustomButton sizeButton="medium" typeButton="primary" onClick={onAction} loading={onActionLoading}>
                {actionText}
              </CustomButton>
            ) : null}
            <img
              src={arrowsOutLineVertical}
              alt="arrow"
              className={styles.imgButton}
              onClick={() => {
                if (isOpen) close();
                if (!isOpen) open();
              }}
            />
          </div>
        </div>
      </CustomDropdown>
    </div>
  ) : (
    <div></div>
  );
};
